import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Grid } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { generateBlockList } from '../components/BlockList/BlockList.js';

var BlockGridLayout = function BlockGridLayout(_ref) {
  var _attributes$gap, _attributes$gap2, _attributes$gap3, _attributes$gap4, _attributes$gap5;
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  // Defaults
  var attributes = Object.assign({
    gridTemplateColumns: {
      default: 'repeat(12, minmax(0, 1fr))'
    },
    gap: {
      default: 'md',
      lg_lte: 'md',
      sm_lte: 'md'
    },
    justifyContent: {
      default: 'center'
    },
    alignItems: {
      default: 'center'
    },
    // When child of things that center the content, we still want
    // Grid to be stretched. For example, as child of Carousel.
    alignSelf: {
      default: 'stretch'
    }
  }, attrs);

  // Backwards compat for gap restrictions.
  if ((attributes === null || attributes === void 0 || (_attributes$gap = attributes.gap) === null || _attributes$gap === void 0 ? void 0 : _attributes$gap.lg_lte) === 'xl' || !(attributes !== null && attributes !== void 0 && (_attributes$gap2 = attributes.gap) !== null && _attributes$gap2 !== void 0 && _attributes$gap2.lg_lte)) {
    attributes.gap.lg_lte = 'md';
  }
  if ((attributes === null || attributes === void 0 || (_attributes$gap3 = attributes.gap) === null || _attributes$gap3 === void 0 ? void 0 : _attributes$gap3.sm_lte) === 'lg' || (attributes === null || attributes === void 0 || (_attributes$gap4 = attributes.gap) === null || _attributes$gap4 === void 0 ? void 0 : _attributes$gap4.sm_lte) === 'xl' || !(attributes !== null && attributes !== void 0 && (_attributes$gap5 = attributes.gap) !== null && _attributes$gap5 !== void 0 && _attributes$gap5.sm_lte)) {
    attributes.gap.sm_lte = 'md';
  }
  return /*#__PURE__*/React.createElement(Grid, _extends({
    key: index,
    display: "grid"
  }, attributes), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockGridLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({}),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var GridLayout = BlockGridLayout;

export { GridLayout as default };
